import { ofType } from "redux-observable";
import { from, of } from "rxjs";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { GENERATE_REPORT_ASYNC_FAILURE, GENERATE_REPORT_ASYNC_REQUEST, GENERATE_REPORT_ASYNC_SUCCESS } from "../../../actions/types";
import { generateReportAsync, resetIsTriggerGenerateReportAsync } from "../../../actions";
import { addNotification } from "../../../actions/ui";
import { DEFAULT_NOTIFICATION_CLOSE_TIMEOUT, NotificationTypeEnum } from "../../../actions/ui/types";
export var generateReportAsyncEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe(ofType(GENERATE_REPORT_ASYNC_REQUEST), switchMap(function(action) {
        return from(api.reportsCenterService.generateReportAsync(action.payload).pipe(mergeMap(function(response) {
            return of(generateReportAsync.success(response), addNotification({
                type: NotificationTypeEnum.SUCCESS,
                action: GENERATE_REPORT_ASYNC_SUCCESS,
                body: "generate_report_notifications.success",
                timeout: 15000
            }));
        }), catchError(function(err) {
            return of(generateReportAsync.failure(err), resetIsTriggerGenerateReportAsync(), addNotification({
                type: NotificationTypeEnum.ERROR,
                action: GENERATE_REPORT_ASYNC_FAILURE,
                body: "error_messages.default",
                timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
            }));
        })));
    }));
};
export default generateReportAsyncEpic;

//# sourceMappingURL=index.js.map